// Auto-generated from octomil-contracts. Do not edit.

export enum ModelStatus {
  NotCached = "not_cached",
  Downloading = "downloading",
  Ready = "ready",
  Error = "error",
}
